import { render, staticRenderFns } from "./ApprovalCard.vue?vue&type=template&id=5b2b4083&scoped=true&"
import script from "./ApprovalCard.vue?vue&type=script&lang=ts&"
export * from "./ApprovalCard.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalCard.vue?vue&type=style&index=0&id=5b2b4083&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b4083",
  null
  
)

export default component.exports